import React, { useContext } from 'react';
import Context from './Context';

interface VariantProps {
  id: string;
  // children: React.ReactChildren;
}

const Variant: React.FC<VariantProps> = (props: VariantProps) => {
  const { id, children } = props;
  const variant = useContext(Context);
  return <>{id === variant ? <>{children}</> : null}</>;
};

export default Variant;
